import React from "react";
import { TRIAL_DEFAULT_DESCRIPTION } from "../constants";

interface TrialProps {
	description?: string;
	subscribeLink: string;
}

export function Trial({
	description = TRIAL_DEFAULT_DESCRIPTION,
	subscribeLink,
}: TrialProps) {
	return (
		<section className="section--trial">
			<div className="container typography">
				<p className="section-title">Try us out before you buy!</p>
				<p className="section-description">{description}</p>
				<ul className="ticks ticks--small">
					<li>After 14 days, the trial ceases automatically</li>
					<li>No credit card required</li>
					<li>No commitment</li>
				</ul>
				<div className="btn-group">
					<a href={subscribeLink} className="btn btn--primary">
						Buy/Trial
					</a>
				</div>
			</div>
		</section>
	);
}
